import remarkParse from "remark-parse";
import remarkStringify from "remark-stringify";
import { unified } from "unified";
import { remove } from "unist-util-remove";
import { visit } from "unist-util-visit";

const ALLOWED_TYPES = new Set([
  "root",
  "paragraph",
  "text",
  "emphasis",
  "strong",
  "heading",
  "list",
  "listItem",
  "link",
]);

export function sanitizeMarkdown(markdown: string): string {
  const tree = unified().use(remarkParse).parse(markdown);

  remove(tree, (node: any) => !ALLOWED_TYPES.has(node.type));

  // Normalize all headings to h3
  visit(tree, "heading", (node: any) => {
    node.depth = 3;
  });

  return String(
    unified().use(remarkStringify, { setext: false }).stringify(tree),
  );
}
